__turbopack_context__.v({
  "instagramEmbed": "ULhbtq_instagramEmbed",
});
